import React from 'react';
import { useIntl } from 'react-intl';
import { useAccountState } from 'contexts/account/account-context';
import { Clipboard } from 'lucide-react';
import TabsHeader from 'components/tabs-header';

type Props = {
  intro?: React.ReactNode;
  actions?: React.ReactNode;
  utils?: React.ReactNode;
};

const FishCheckTabsHeader: React.FC<Props> = ({ intro, actions, utils }) => {
  const intl = useIntl();
  const { account } = useAccountState();

  return (
    <TabsHeader
      tabs={[
        {
          hasAccess: account.company?.features.hasFieldRegistration,
          label: intl.formatMessage({ id: 'fishCheck.navigation.listWelfareScoring' }),
          to: '/fish-check/welfare-scoring',
        },
      ]}
      intro={intro}
      actions={actions}
      utils={utils}
      icon={<Clipboard size={25} color={'white'} />}
    />
  );
};

export default React.memo(FishCheckTabsHeader);
